import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import TabPage from "./../factories/tab-page";
import baoRouter from "../services/bao-router";
class UserTaggingOverview {

    private subscriptions: KnockoutSubscription[] = [];
    private PageIndex: KnockoutObservable<number> = ko.observable<number>(0).extend({ notify: 'always' });
    private TotalRows: KnockoutObservable<number> = ko.observable<number>(0);
    private PageSize: KnockoutObservable<number> = ko.observable<number>(20);
    private UserTagCollection: KnockoutObservableArray<any> = ko.observableArray();

    constructor(public tabPage: TabPage) {
        Bao.Session.GetMessage("msgUserTagging").then((result) => {
            this.tabPage.Title(result);
        });
        this.subscriptions.push(BaoMenu.notificationCount.subscribe((count) => {
            this.refreshMentions();
        }));
        this.subscriptions.push(this.tabPage.IsActiveTab.subscribe((isActive) => {
            if (!isActive && BaoMenu.notificationCount() > 0) {
                this.markMentionsAsRead(this.UserTagCollection());
            }
        }));
        this.subscriptions.push(this.PageIndex.subscribe(this.refreshMentions));
        this.subscriptions.push(this.PageSize.subscribe(() => this.PageIndex(0)));
    }
    init() {
        this.tabPage.IsLoading(true);
        return this.getMentions().always(() => {
            this.tabPage.IsLoading(false);
        });
    }
    getMentions() {
        let d = $.Deferred<void>();
        Bao.post("UserTagging/GetAllUserTaggingMentions", JSON.stringify({
            userId: Bao.Session.User.UserId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize()
        }), (result) => {
            this.UserTagCollection((result.Models as Array<any>).map(model => {
                model.EntityTypeHtml = Bao.Session.GetMessage('msg' + model.EntityType);
                return model;
            }));
            this.TotalRows(result.TotalRows);
            d.resolve();
        });
        return d.promise();
    }
    refreshMentions = () => {
        this.tabPage.IsLoading(true);
        this.getMentions().always(() => {
            this.tabPage.IsLoading(false);
        });
    }
    markMentionsAsRead(mentionsCollection) {
        Bao.post("UserTagging/MarkAsRead", JSON.stringify({ userTags: mentionsCollection.filter(el => !el.HasRead)}));
    }
    goToMention(item) {
        switch (item.EntityType) {
            case "Info":
                // Get the latest possible event
                Bao.post("UserTaggingOverview/GetNewestPossibleReportIdForUserTaggingOverviewToOpenInfo", JSON.stringify({
                    infoid: item.EntityId
                })).done((result) => {
                    baoRouter.setHash("report/" + result + "/info/" + item.EntityId);
                })
                break;
            case "Instruction":
                baoRouter.setHash("instruction/" + item.EntityId);
                break;
            case "Task":
                baoRouter.setHash("task/" + item.EntityId);
                break;
            case "Whiteboard":
                baoRouter.setHash("whiteboard/" + item.EntityId);
                break;
            case "ReminderTicket":
                baoRouter.setHash("reminderticket/" + item.EntityId);
                break
            case "Ticket":
                baoRouter.setHash("ticket/" + item.EntityId);
                break;
            default:
        }
    }
}
export default UserTaggingOverview;